import React from 'react';
import AppIcon from '../AppIcon';

const ICON_MAP = {
  MapPinIcon: 'MapPin',
  ChevronUpIcon: 'ChevronUp',
  ChevronDownIcon: 'ChevronDown',
  ChevronLeftIcon: 'ChevronLeft',
  ChevronRightIcon: 'ChevronRight',
  ArrowRightIcon: 'ArrowRight',
  XMarkIcon: 'X',
  XCircleIcon: 'XCircle',
  BookmarkIcon: 'Bookmark',
  CheckIcon: 'Check',
  CheckCircleIcon: 'CheckCircle',
  InformationCircleIcon: 'Info',
  ExclamationTriangleIcon: 'TriangleAlert',
  ShieldCheckIcon: 'ShieldCheck',
  DevicePhoneMobileIcon: 'Smartphone',
  EyeIcon: 'Eye',
  EyeSlashIcon: 'EyeOff',
  ArrowPathIcon: 'RefreshCw',
  GlobeAltIcon: 'Globe',
  UserPlusIcon: 'UserPlus',
  PlusIcon: 'Plus',
  PlusCircleIcon: 'PlusCircle',
  MapIcon: 'Map',
  ListBulletIcon: 'List',
  MagnifyingGlassIcon: 'Search',
  FunnelIcon: 'Filter',
  UserIcon: 'User',
  UsersIcon: 'Users',
  UserGroupIcon: 'Users',
  BellIcon: 'Bell',
  LockClosedIcon: 'Lock',
  ClockIcon: 'Clock',
  BoltIcon: 'Zap',
  CalendarDaysIcon: 'Calendar',
  CalendarIcon: 'Calendar',
  ChartBarIcon: 'BarChart3',
  ChatBubbleLeftIcon: 'MessageCircle',
  ChatBubbleLeftRightIcon: 'MessagesSquare',
  PaperAirplaneIcon: 'Send',
  BuildingOfficeIcon: 'Building2',
  ShoppingBagIcon: 'ShoppingBag',
  CheckBadgeIcon: 'BadgeCheck',
  PencilIcon: 'Pencil',
  EllipsisVerticalIcon: 'MoreVertical',
  AdjustmentsHorizontalIcon: 'SlidersHorizontal',
  ArrowRightOnRectangleIcon: 'LogIn',
  ClipboardDocumentListIcon: 'ClipboardList',
  DocumentTextIcon: 'FileText',
  CameraIcon: 'Camera',
  StarIcon: 'Star',
  TrophyIcon: 'Trophy',
  FireIcon: 'Flame',
  SignalIcon: 'Signal',
  WifiIcon: 'Wifi',
  BatteryIcon: 'Battery',
};

const normalizeName = (name) => {
  if (!name) return '';
  if (ICON_MAP[name]) return ICON_MAP[name];
  if (typeof name === 'string' && name.endsWith('Icon')) {
    const candidate = name.slice(0, -4);
    if (ICON_MAP[candidate + 'Icon']) return ICON_MAP[candidate + 'Icon'];
    return candidate;
  }
  return String(name);
};

const OpenPlayIcon = ({ name, variant, size = 24, className = '', ...props }) => {
  // `variant` is ignored (openplay_map used Heroicons outline/solid). We keep signature for compatibility.
  const mapped = normalizeName(name);
  return <AppIcon name={mapped} size={size} className={className} {...props} />;
};

export default OpenPlayIcon;
